<ng-container *ngIf="isMobile else web">
	<app-bo-kyc-lvl2-identity-type-selected-mobile-v2>
	</app-bo-kyc-lvl2-identity-type-selected-mobile-v2>
</ng-container>
<ng-template #web>
	<app-bo-kyc-lvl2-identity-type-selected-web-v2>
	</app-bo-kyc-lvl2-identity-type-selected-web-v2>
</ng-template>
